"use client";

import * as React from "react";
import { EcommerceProductsProvider, useEcommerceProducts, AddToCartButton } from "@/integrations/wordpress/WordPressEcommerceProductsProvider";
import { Link } from "@/components/common/Link";
function ProductGridConsumer() {
  const {
    products,
    loading,
    error,
    refetch
  } = useEcommerceProducts();
  const [hoveredProduct, setHoveredProduct] = React.useState<number | null>(null);
  if (loading) {
    return <div className="grid grid-cols-1 gap-8 md:grid-cols-2 lg:grid-cols-4">
        {[...Array(8)].map((_, i) => <div key={i} data-index={i} className="space-y-4">
            <div className="aspect-square rounded-lg bg-muted/30 animate-pulse" />
            <div className="h-4 w-3/4 rounded bg-muted/30 animate-pulse" />
            <div className="h-4 w-1/2 rounded bg-muted/30 animate-pulse" />
          </div>)}
      </div>;
  }
  if (error) {
    return <div className="text-center py-12">
        <p className="text-muted-foreground text-sm mb-4">Error al cargar productos.</p>
        <button onClick={refetch} className="text-accent underline text-sm">
          Reintentar
        </button>
      </div>;
  }
  if (products.length === 0) {
    return <p className="text-center text-muted-foreground py-12">
        No hay productos disponibles en este momento.
      </p>;
  }
  return <div className="grid grid-cols-1 gap-8 md:grid-cols-2 lg:grid-cols-4">
      {products.map((product, i) => <article key={product.id} data-index={i} className="group relative" onMouseEnter={() => setHoveredProduct(product.id)} onMouseLeave={() => setHoveredProduct(null)}>
          <Link to={product.link}>
            <div className="aspect-square overflow-hidden rounded-lg bg-muted mb-4 relative">
              {product.featured_image_url ? <img src={product.featured_image_url} alt={product.title} className="h-full w-full object-cover transition-transform duration-[var(--duration-medium)] ease-[var(--ease-out-back)] group-hover:scale-[1.02]" loading="lazy" /> : <div className="h-full w-full flex items-center justify-center bg-muted">
                  <span className="text-muted-foreground text-sm">Sin imagen</span>
                </div>}
              
              {product.tags && product.tags.length > 0 && product.tags[0] && <div className="absolute top-3 left-3">
                  <span className="inline-block px-3 py-1 text-xs font-medium tracking-wide uppercase bg-accent text-foreground-accent rounded-sm shadow-soft">
                    {product.tags[0]}
                  </span>
                </div>}

              <div className="absolute bottom-0 left-0 right-0 p-4 transition-opacity duration-[var(--duration-fast)]" style={{
            opacity: hoveredProduct === product.id ? 1 : 0,
            pointerEvents: hoveredProduct === product.id ? "auto" : "none"
          }}>
                <AddToCartButton productId={product.id} variant="default" size="sm" className="w-full" buttonClassName="bg-primary text-foreground-primary" text="Añadir al carrito" showQuantity={false} />
              </div>
            </div>
          </Link>

          <div className="space-y-1">
            <h3 className="font-display text-base font-semibold tracking-tight leading-tight text-foreground">
              {product.title}
            </h3>
            
            {product.categories && product.categories.length > 0 && <p className="text-xs text-muted-foreground uppercase tracking-wider">
                {product.categories[0]}
              </p>}
            
            <div className="flex items-baseline gap-2 pt-1">
              {product.discounted_price !== undefined && product.discounted_price < product.price ? <>
                  <span className="text-lg font-semibold text-foreground">
                    ${product.discounted_price.toFixed(2)} MXN
                  </span>
                  <span className="text-sm text-muted-foreground line-through">
                    ${product.price.toFixed(2)}
                  </span>
                </> : <span className="text-lg font-semibold text-foreground">
                  ${product.price.toFixed(2)} MXN
                </span>}
            </div>
          </div>
        </article>)}
    </div>;
}
export default function ProductGrid() {
  return <section id="product-grid" className="py-16 px-6 md:px-12 lg:px-24 bg-background">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="font-display text-4xl md:text-5xl font-bold tracking-tight text-foreground mb-3">
            Nueva Colección
          </h2>
          <p className="text-muted-foreground text-base max-w-2xl mx-auto">
            Descubre piezas atemporales cuidadosamente seleccionadas para definir tu estilo único
          </p>
        </div>

        <EcommerceProductsProvider postType="product" wp_query={{
        per_page: 12,
        order: "desc",
        orderby: "date"
      }} fields={["id", "title.rendered", "price", "discounted_price", "featured_image_url", "categories", "tags", "link"]} className="w-full">
          <ProductGridConsumer />
        </EcommerceProductsProvider>
      </div>
    </section>;
}